import React, { PureComponent } from "react";
import { LocaleContext } from "../locale-context";

import en from "./en.json";
import tr from "./tr.json";
import de from "./de.json";
import cz from "./cz.json";
import ru from "./ru.json";
import ar from "./ar.json";
import uz from "./uz.json";

export default class Translate extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      langs: {
        en,
        tr,
        de,
        ru,
        cz,
        ar,
        uz
      }
    };
  }
  render() {
      const {langs} = this.state 
      const {string} = this.props
    
    return (
      <LocaleContext.Consumer>
        {value => langs[value][string]}
      </LocaleContext.Consumer>
    );
  }
}